import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const areaManagerParentPreviewsWrapper: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;

  > div:first-child {
    position: relative;
    z-index: 2;
  }

  > div:last-child {
    position: relative;
    z-index: 1;
    margin-left: -${theme.remSize[100]};
  }
`;
